import React from "react";
import { Icon } from "../Icon";
import { Button } from "./Button";

/**
 * Empty state DS — patrón "qué falta + qué hacer" del README.
 *
 * <EmptyState
 *   icon="Calendar"
 *   title="Aún no hay solicitudes este mes"
 *   description="Crea una nueva solicitud para empezar."
 *   action={{ label: "Nueva solicitud", icon: "Plus", onClick: () => ... }}
 * />
 */
export function EmptyState({ icon, title, description, action, secondaryAction, style }) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "48px 24px",
        ...(style || {}),
      }}
    >
      {icon && (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: 999,
            background: "var(--kr-bg-subtle)",
            color: "var(--kr-fg-muted)",
            marginBottom: 16,
          }}
        >
          <Icon name={icon} size={24} />
        </div>
      )}
      {title && (
        <div
          style={{
            fontSize: 16,
            fontWeight: 600,
            color: "var(--kr-fg-strong)",
            marginBottom: 6,
          }}
        >
          {title}
        </div>
      )}
      {description && (
        <p
          style={{
            margin: "0 auto 18px",
            maxWidth: 420,
            color: "var(--kr-fg-muted)",
            fontSize: 13,
            lineHeight: 1.5,
          }}
        >
          {description}
        </p>
      )}
      {(action || secondaryAction) && (
        <div
          style={{
            display: "inline-flex",
            gap: 8,
          }}
        >
          {secondaryAction && (
            <Button
              variant="secondary"
              size="md"
              icon={secondaryAction.icon}
              onClick={secondaryAction.onClick}
            >
              {secondaryAction.label}
            </Button>
          )}
          {action && (
            <Button
              variant="primary"
              size="md"
              icon={action.icon}
              onClick={action.onClick}
            >
              {action.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}

export default EmptyState;
